import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/drawer/drawer-start.styles.ts
var drawer_start_styles_default = r` :host { display: block; } .drawer-start { height: 50px; display: flex; flex-direction: row; align-items: center; overflow: hidden; padding: 0 var(--sl-spacing-3x-small); } .drawer-start__logo { display: flex; padding-left: var(--sl-spacing-x-small); transition: 300ms all ease-out; } .drawer-start--open .drawer-start__logo { padding-left: var(--sl-spacing-large); } .drawer-start__logo img, .drawer-start__logo ::slotted(img) { height: 30px; width: 30px; } .drawer-start__content { display: flex; padding: 0 var(--sl-spacing-small); transition: 300ms all ease-out; opacity: 0; } .drawer-start__content * { white-space: nowrap; } .drawer-start--open .drawer-start__content { opacity: 1; } `;

export {
  drawer_start_styles_default
};
